export const COMPANY_PATH_NAME = 'company';
